




















import type { PropType } from '@vue/composition-api';
import { defineComponent } from '@vue/composition-api';
import { ModalSize } from '@getaccept/lib-ui';
import type { Recipient } from '@getaccept/lib-shared/src/types/Recipient';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import RecipientItem from '@getaccept/dsr-shared/src/components/RecipientItem.vue';
import { UniversalLink } from '@getaccept/dsr-shared';
import { UrlHelper } from '@getaccept/lib-shared/src/helpers/url.helper';

export default defineComponent({
  name: 'RecipientsOverviewModal',
  components: {
    RecipientItem,
    UniversalLink,
  },
  props: {
    recipients: {
      type: Array as PropType<Recipient>,
      default: () => [],
    },
    universalLink: {
      type: String,
      default: '',
      validator: (value: string) => {
        if (!value) {
          return true;
        }
        return UrlHelper.isValidUrl(value);
      },
    },
    showUniversalLink: {
      type: Boolean,
    },
  },
  setup() {
    return {
      ModalSize,
      t,
    };
  },
});
